'use strict';

var wrapObjectMatcher = require('../internal/wrapObjectMatcher');

module.exports = {
  objectSome: wrapObjectMatcher('some'),
  objectFind: wrapObjectMatcher('find'),
  objectEvery: wrapObjectMatcher('every')
};


//////////////////
// WEBPACK FOOTER
// ./~/sugar/enumerable/var/objectMatchers.js
// module id = 79
// module chunks = 0